export default __webpack_public_path__ + "static/media/icn-bac-failed.13ee344b.svg";